import { QueryKeys } from '../../../queryKeys';
import { getRequest } from '../../../helpers/apiClient';
import apiRoutes from '../../../api-routes';
import { useQueryWithLogout } from '../../../hooks/useQueryWithLogout';

export const useDocumentRecipients = (filters, options) => {
  return useQueryWithLogout(
    [QueryKeys.DOCUMENT_RECIPIENTS, filters, options.id],
    async () => {
      const { data } = await getRequest({
        url: apiRoutes.DOCUMENT_RECIPIENTS.replace('{id}', options?.id),
        params: filters,
      });

      return data;
    },
    options,
  );
};
